import { KanbanBoard } from './KanbanBoard';

interface TaskBoardViewProps {
  projectId: string;
  boardId: string;
}

export function TaskBoardView({ projectId, boardId }: TaskBoardViewProps) {
  return <KanbanBoard projectId={projectId} boardId={boardId} />;
}
